import {useLocation} from "react-router-dom";
import IconArrowUpRight from "../../assets/arrow-up-right.svg?react";
import {dibApi} from "../chat/dibApi";
import layoutClasses from "./ContentLayout.module.css";
import classes from "./ExternalFallback.module.css";

function getDibBaseUrl(): string {
    const hostname = window.location.hostname;
    if (hostname === "localhost" || hostname === "ai.dibdev.no") {
        return "https://dib.dibdev.no";
    }
    return "https://app.dib.no";
}

/**
 * Fallback for resource types that ContentPage doesn't support yet.
 * ContentPage only renders "vanlig" HTML content (resourceTypeId "19").
 * For everything else — PDFs, checklists, Office documents, etc. — we
 * link the user out to the legacy dib app where full rendering exists.
 */
export const ExternalFallback = ({
    resourceId,
    segmentId,
}: {
    resourceId: string;
    segmentId: string | undefined;
}) => {
    const location = useLocation();
    const {data: documentData} = dibApi.endpoints.getDocument.useQuery({
        resourceId,
        segmentId,
    });

    return (
        <div className={layoutClasses.page}>
            <article className={layoutClasses.article}>
                <div className={layoutClasses.articleInner}>
                    <div className={classes.fallback}>
                        <span className={classes.fallbackLabel}>
                            Available on dib
                        </span>
                        {documentData?.name && (
                            <h2 className={classes.fallbackTitle}>
                                {documentData.name}
                            </h2>
                        )}
                        <a
                            className={classes.fallbackCta}
                            href={`${getDibBaseUrl()}${location.pathname}`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Open in dib
                            <IconArrowUpRight
                                className={classes.fallbackCtaIcon}
                            />
                        </a>
                    </div>
                </div>
            </article>
        </div>
    );
};
